import useSWR from 'swr';

import { fetchMembers, type FamilyMember } from '../data/familyRepository.js';

export const MEMBERS_KEY = 'family/members';

export type MembersState =
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | { status: 'ready'; members: readonly FamilyMember[]; refresh: () => Promise<unknown> };

/** Who is in the household right now (plan step 1.8). */
export function useMembers(householdId: string | null): MembersState {
  const { data, error, isLoading, mutate } = useSWR<readonly FamilyMember[], Error>(
    householdId === null ? null : `${MEMBERS_KEY}:${householdId}`,
    () => fetchMembers(householdId!),
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );

  if (error) {
    return {
      status: 'error',
      message: error.message || 'Không tải được danh sách thành viên.',
      retry: () => {
        void mutate();
      },
    };
  }

  if (isLoading || data === undefined) return { status: 'loading' };

  return { status: 'ready', members: data, refresh: () => mutate() };
}
